import axios from "axios";

import { UserFilters } from "../store/types/user-types";

const API_URL = process.env.REACT_APP_API_URL;

export const downloadUsersCsv = async (
  filters: UserFilters,
  token: string,
): Promise<string> => {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value.toString());
    }
  });

  const response = await axios.get(
    `${API_URL}/users/export?${params.toString()}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    },
  );

  const disposition = response.headers["content-disposition"] || "";
  const filenameMatch = disposition.match(/filename="?([^";]+)"?/i);
  const filename =
    filenameMatch?.[1] ||
    `users-${new Date().toISOString().slice(0, 10)}.csv`;
  const downloadUrl = window.URL.createObjectURL(
    new Blob([response.data], { type: "text/csv;charset=utf-8" }),
  );
  const link = document.createElement("a");

  link.href = downloadUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 0);

  return filename;
};
